import { createRouter, createWebHashHistory } from 'vue-router';
import CustomerTypeSelectionView from '../views/CustomerTypeSelectionView.vue';
import YourProfessionSelectionView from '../views/YourProfessionSelectionView.vue';
import PostcodeSelectionView from '../views/PostcodeSelectionView.vue';
import YourFinancialAdviserView from '../views/YourFinancialAdviserView.vue';
import StepTwoAlternativeExistingCustomerDetailsView from '../views/StepTwoAlternativeExistingCustomerDetailsView.vue';
import ConfirmationErrorScreenView from '../views/ConfirmationErrorScreenView.vue';
import FinancialExpectationsView from '../views/FinancialExpectationsView.vue';
import KnowYourFinancialAdviserSelectionView from '../views/KnowYourFinancialAdviserSelectionView.vue';
import FinancialAdviserSelectionView from '../views/FinancialAdviserSelectionView.vue';

import { useAppointmentReferralStore } from '../stores/appointmentReferralStore.js';

const router = createRouter({
	history: createWebHashHistory(),
	routes: [
		{
			path: '/referral',
			children: [
				{
					path: 'customer-type',
					name: 'customer-type',
					component: CustomerTypeSelectionView,
				},
				{
					path: 'know-your-fc',
					name: 'know-your-fc',
					component: KnowYourFinancialAdviserSelectionView,
					beforeEnter: (to, from) => {
						if (from.name !== 'know-your-fc' && from.name !== 'customer-type' && from.name !== 'fc-selection' || !from.name) {
							return { name: 'customer-type' };
						}
					}
				},
				{
					path: 'fc-selection',
					name: 'fc-selection',
					component: FinancialAdviserSelectionView,
					beforeEnter: (to, from) => {
						if (from.name !== 'fc-selection' && from.name !== 'know-your-fc' || !from.name) {
							return { name: 'customer-type' };
						}
					}
				},
				{
					path: 'your-financial-adviser',
					name: 'your-financial-adviser',
					component: YourFinancialAdviserView,
					beforeEnter: (to, from) => {
						if (from.name !== 'your-financial-adviser' && from.name !== 'fc-selection' && from.name !== 'postcode' && from.name !== 'details' && from.name !== 'customer-type' && from.name !== 'before-you-book' || !from.name) {
							return { name: 'customer-type' };
							}
						},
				},
				{
					path: 'profession',
					name: 'profession',
					component: YourProfessionSelectionView,
					beforeEnter: (to, from) => {
						if (from.name !== 'profession' && from.name !== 'know-your-fc' && from.name != 'error' && from.name !== 'customer-type' && from.name !== 'postcode' || !from.name) {
							return { name: 'customer-type' };
						  }
					  },
				},
				{
					path: 'details',
					name: 'details',
					component: StepTwoAlternativeExistingCustomerDetailsView,
					beforeEnter: (to, from) => {
						if (from.name !== 'details' && from.name !== 'customer-type' || !from.name) {
							return { name: 'customer-type' };
						  }
					  },
				},
				{
					path: 'postcode',
					name: 'postcode',
					component: PostcodeSelectionView,
					beforeEnter: (to, from) => {
						if (from.name !== 'postcode' && from.name !== 'profession' || !from.name) {
							return { name: 'customer-type' };
						  }
					  },
				},
				{
					path: 'before-you-book',
					name: 'before-you-book',
					component: FinancialExpectationsView,
					beforeEnter: (to, from) => {
						if (from.name !== 'before-you-book' && from.name !== 'postcode' || !from.name) {
							return { name: 'customer-type' };
						  }
					  },
				},
				{
					path: 'success',
					name: 'success',
					component: ConfirmationErrorScreenView,
					beforeEnter: (to, from) => {
						if (from.name != 'success' && from.name !== 'your-financial-adviser' || !from.name) {
							return { name: 'customer-type' };
						  }
					  },
				},
				{
					path: 'error',
					name: 'error',
					component: ConfirmationErrorScreenView,
					props:  { unableToMatchCustomerDetails: true},
					beforeEnter: (to, from) => {
						if (from.name != 'error' && from.name !== 'details' && from.name !== 'your-financial-adviser' || !from.name) {
							return { name: 'customer-type' };
						  }
					  },
				},
				{
					path: 'adviser-error',
					name: 'adviser-error',
					component: ConfirmationErrorScreenView,
					props:  { cantFindFinancialAdviser: true},
					beforeEnter: (to, from) => {
						if (from.name != 'adviser-error' && from.name !== 'your-financial-adviser' || !from.name) {
							return { name: 'customer-type' };
						  }
					  },
				},
				{
					path: 'form-unavailable',
					name: 'form-unavailable',
					component: ConfirmationErrorScreenView,
					props: { cantFindFinancialAdviser: true }
				},
				{
					path: '/',
					redirect: '/referral/customer-type',
				},
				{
					path: ':pathMatch(.*)*',
					redirect: '/referral/customer-type',
				},
			],
		},
	],
	scrollBehavior(to, from, savedPosition) {
		// This allows us to create a <router-link> with a href="#element-id" and have it scroll to that element, rather
		// than having to do it via vanilla js
		if (to.hash) {
			return {
				el: to.hash,
				behavior: 'smooth',
			};
		}

		if (savedPosition) {
			return savedPosition
		} else {
			return { top: 0 }
		}
	}
});

export default router;
